// All time-log times — labels, table cells, picker inputs, picker outputs,
// filter URL params — must round-trip through the venue's IANA zone, not
// the browser's. The backend exposes `venue.ianaTimeZone` (always IANA);
// these helpers wrap moment-timezone so callers don't have to remember the
// wall-clock vs. UTC dance every time.
import moment from "moment-timezone";

const FALLBACK_ZONE = "Etc/UTC";

export const venueTimeZone = (venue) => {
  if (venue && venue.ianaTimeZone) return venue.ianaTimeZone;
  return FALLBACK_ZONE;
};

// Short abbreviation ("PST", "CEST") for a given IANA zone, valid for now.
export const tzAbbr = (tz) => moment.tz(tz || FALLBACK_ZONE).format("z");

// Format a UTC ISO timestamp into the venue's wall clock + abbreviation.
export const formatInZone = (iso, tz, fmt = "MMM D, YYYY h:mm A z") => {
  if (!iso) return "";
  const m = moment.tz(iso, tz || FALLBACK_ZONE);
  return m.isValid() ? m.format(fmt) : "";
};

// Pre-fill the DatePicker so the bulma widget shows the venue's wall clock,
// regardless of the browser's local zone. We hand the picker a Date whose
// JS local-time components match the venue-tz wall clock.
export const isoToPickerDate = (iso, tz) => {
  if (!iso) return null;
  const m = moment.tz(iso, tz || FALLBACK_ZONE);
  if (!m.isValid()) return null;
  // Construct the Date from explicit components so the browser's tz can't
  // shift the wall clock.
  return new Date(
    m.year(),
    m.month(),
    m.date(),
    m.hour(),
    m.minute(),
    m.second(),
  );
};

// Convert whatever the picker hands back (Date or string), interpreting the
// wall-clock components as venue-local time, into a UTC ISO string suitable
// for the API.
export const pickerValueToIso = (value, tz) => {
  if (!value) return null;
  const m = moment(value);
  if (!m.isValid()) return null;
  const wall = m.format("YYYY-MM-DDTHH:mm:ss");
  return moment.tz(wall, tz || FALLBACK_ZONE).toISOString();
};
